import { DATA_POINTS, TYPES } from './constants';
import { FALLBACK_METADATA_DESCRIPTION } from '@/lib/constants/content';

export const organizationRef = {
  '@id': `${DATA_POINTS.url.base}/#organization`,
};

export const websiteRef = {
  '@id': `${DATA_POINTS.url.base}/#website`,
};


export { DATA_POINTS, TYPES } from './constants';
export {
  buildBrand,
  buildOwnBrand,
  buildBrandFromProduct,
} from './BrandSchema';
export {
  buildImageSchemas,
  extractImages,
  imageProperty,
  imagePropertyFromAsset,
} from './imageUtils';
export const logoProperty = {
  logo: {
    '@type': TYPES.image_object,
    url: DATA_POINTS.image.logo,
    width: DATA_POINTS.image.schemaLogoWidth,
    height: DATA_POINTS.image.schemaLogoHeight,
  },
};

export const publisherProperty = {
  publisher: {
    '@id': `${DATA_POINTS.url.base}/#organization`,
  },
};




export const areaServedProperty = DATA_POINTS.markets?.map((market) => ({
  '@type': TYPES.country,
  name: market.name,
  identifier: market.code,
})) || [];
export const contactPointProperty = {
  contactPoint: [
    {
      '@type': TYPES.contact_point,
      contactType: DATA_POINTS.contact.customerService.type,
      email: DATA_POINTS.contact.email,
      telephone: DATA_POINTS.contact.telephone,
      areaServed: areaServedProperty,
      availableLanguage: DATA_POINTS.contact.languages,
      description: `Email: ${DATA_POINTS.contact.emailResponseTime}`,
    },
    {
      '@type': TYPES.contact_point,
      contactType: DATA_POINTS.contact.liveChat.type,
      areaServed: areaServedProperty,
      availableLanguage: DATA_POINTS.contact.languages,
    },
    {
      '@type': TYPES.contact_point,
      contactType: DATA_POINTS.contact.textSupport.type,
      telephone: DATA_POINTS.contact.textTelephone,
      areaServed: areaServedProperty,
      availableLanguage: DATA_POINTS.contact.languages,
      description: DATA_POINTS.contact.textInstructions,
    },
  ],
};

export const sameAsProperty = {
  sameAs: [
    DATA_POINTS.url.social.facebook,
    DATA_POINTS.url.social.instagram,
    DATA_POINTS.url.social.x,
    DATA_POINTS.url.social.youtube,
    DATA_POINTS.url.social.linkedin,
  ],
};


export const websiteProperty = (metadata, { dateModified } = {}) => ({
  '@type': TYPES.web_site,
  ...websiteRef,
  name: DATA_POINTS.name,
  alternateName: [DATA_POINTS.alternateName],
  description: metadata?.description || FALLBACK_METADATA_DESCRIPTION,
  url: DATA_POINTS.url.base,
  publisher: organizationRef,
  potentialAction: [
    {
      '@type': TYPES.view_action,
      name: DATA_POINTS.website.viewCartActionName,
      target: DATA_POINTS.url.cart,
    },
  ],
  inLanguage: DATA_POINTS.locale.language,
  copyrightYear: Number(DATA_POINTS.foundingDate),
  copyrightHolder: organizationRef,
  about: {
    '@type': TYPES.thing,
    name: DATA_POINTS.website.about,
  },
  keywords: DATA_POINTS.website.keywords,
  audience: {
    '@type': TYPES.audience,
    audienceType: DATA_POINTS.website.audience.audienceType,
    geographicArea: {
      '@type': TYPES.country,
      name: DATA_POINTS.website.audience.geographicArea,
    },
  },
  dateCreated: DATA_POINTS.foundingDate,
  ...(dateModified && { dateModified }),
});



const UNSAFE_CHARS = /[<>&\u2028\u2029]/g;
const REPLACEMENTS = { '<': '\\u003c', '>': '\\u003e', '&': '\\u0026', '\u2028': '\\u2028', '\u2029': '\\u2029' };

export function safeJsonLdStringify(value) {
  return JSON.stringify(value).replace(UNSAFE_CHARS, (c) => REPLACEMENTS[c]);
}

export const Schema = ({ schema, id = 'schema' }) => {
  if (schema && Array.isArray(schema)) {
    return (
      <>
        {schema.filter(Boolean).map((item, index) => {
          const fullSchema = {
            '@context': 'https://schema.org',
            ...item,
          };
          return (
            <script
              key={index}
              id={`${id}-${index}`}
              type="application/ld+json"
              dangerouslySetInnerHTML={{ __html: safeJsonLdStringify(fullSchema) }}
            />
          );
        })}
      </>
    );
  }

  if (!schema) return null;

  const fullSchema = {
    '@context': 'https://schema.org',
    ...schema,
  };

  return (
    <script
      id={id}
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: safeJsonLdStringify(fullSchema) }}
    />
  );
};

export default Schema;
